export const tabsContextKey = Symbol('tabsContextKey')

export const tabsPlacements = [
  'top', 'bottom', 'top-left', 'top-right', 'bottom-left', 'bottom-right'
]